import { GameContext } from '../../../contexts/GameContext';
import { ZdarGameStepConfiguration } from '../../../configuration/games/zdar-escape-game/zdarEscapeGameContentConfiguration';
import React, { useContext } from 'react';
import ZdarHint from './ZdarHint';

type Props = {
    takeHint: () => void;
    showSolution: () => void;
    snow: boolean | null;
};

export default function ZdarHints({ takeHint, showSolution, snow }: Props) {
    const { selectHint, shownHints, stepContent } = useContext(GameContext);
    const { hints, snowHints } = stepContent as ZdarGameStepConfiguration;

    if (!hints) {
        return <React.Fragment />;
    }

    const renderedHints = snow && snowHints ? snowHints : hints;

    const displayedHints = renderedHints.slice(0, shownHints + 1);

    const hint = () => {
        selectHint();
        takeHint();
    };

    return (
        <div className="zdar-hints-wrapper">
            {displayedHints.map((h, i) => {
                return <ZdarHint id={i} hint={h} key={i} selectHint={hint} showSolution={showSolution} />;
            })}
        </div>
    );
}
